import {EventBus} from "../../../../../../common/ts/events/EventBus";
import {WhitelabelEvent} from "../../../../../../common/ts/events/Events";
import {WebPushSearchAddedEvent, WebPushPermissionsUpdatedEvent} from "./events";
import AdFormService from "../../../../../../common/ts/services/AdFormService";
import {WebPushStorage} from "./model/webPushStorage";

const webPushStorage = new WebPushStorage();

interface WebPushSubscriptionResponseBody {
    pushUserId: string,
    isSuccessful: boolean,
    message: string,
}

export function subscribeWebPushSearchHandler(event: WhitelabelEvent) {
    const { payload: { search, subscription} } = event as WebPushSearchAddedEvent;
    const adFormService = new AdFormService();

    adFormService
        .webPushSubscriber(search, subscription, webPushStorage.getPushUserId(), getuqTrovitId())
        .then(response => {
            if (response.status === 201) {
                response.json().then((responseBody: WebPushSubscriptionResponseBody) => {
                    let newPushUserId = responseBody.pushUserId;
                    let oldPushUserId = webPushStorage.getPushUserId()
                    if (oldPushUserId != newPushUserId) {
                        webPushStorage.clearAllSearches();
                    }
                    webPushStorage.savePushUserId(newPushUserId);
                    if (webPushStorage.getSearch(search.what) === undefined) {
                        webPushStorage.saveSearch(search.what);
                    }
                });
            }
        });
}

export function trackWebPushPermissionsEventHandler(event: WhitelabelEvent) {
    const { payload: { pageData, userId, eventType } } = event as WebPushPermissionsUpdatedEvent;
    const adFormService = new AdFormService();
    adFormService.trackWebPushPermissions(pageData, webPushStorage.getPushUserId(), getuqTrovitId(), eventType);
}

function init(eventBus: any = EventBus.getInstance()) {
    eventBus.subscribe(WebPushSearchAddedEvent.TYPE, subscribeWebPushSearchHandler);
    eventBus.subscribe(WebPushPermissionsUpdatedEvent.TYPE, trackWebPushPermissionsEventHandler);
}

function getCookie(ckey: string) {
    var value = '; ' + document.cookie + '; ';
    var parts = value.split('; ' + ckey + '=');
    // @ts-ignore
    var x: string = parts.pop().split(';').shift();
    x = decodeURIComponent(x);
    return x;
}

function getuqTrovitId(): string {
    let uqTrovit = getCookie('uqTrovit');

    return uqTrovit ? (JSON.parse(uqTrovit).id || '') : '';
}

export default {
    init,
};
